import React from "react";
import get from "lodash/get";

const ResultItem = (props) => {
  const {
    items,
    nameSelector = 'translation.title',
    urlSelector = 'translation.url',
    title,
    setActiveCategory,
    setTag,
  } = props;

  if (!items || !items.length) return null;

  return(
    <React.Fragment>
      <h4 className="title">{title}</h4>
      {items.map((item, index) => {
        return (
          <a
            key={item.id}
            onClick={() => {
              if (item.nameId === 'categories') {
                setActiveCategory(item);
              }

              if (item.nameId === 'tags') {
                setTag(item);
              }
            }}
            className={`item`}
          >
            {get(item, nameSelector)}
          </a>
        )
      })}
    </React.Fragment>
  )
};

export default ResultItem;



// WEBPACK FOOTER //
// ./resources/assets/js/components/shop-search/components/ResultItem.jsx